import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Modal from '../core/Modal'
import Button from '../elements/Button'
import Radio from '../elements/Radio'
import { OPTION_USE_EXISTING, OPTION_NEW_ACCOUNT } from '../../constants/content'

const ExistingAccountModal = ({
  visible,
  onCancel,
  getOrderServices,
  fxbuyflowSessionId,
  existingServicesWithBanText,
  newServicesText,
  locationAddress
}) => {
  const [selectedOption, setSelectedOption] = useState(null)

  const handleUseExistingChange = useCallback(() => {
    setSelectedOption(OPTION_USE_EXISTING)
  }, [])
 
  const handleNewAccountChange = useCallback(() => {
    setSelectedOption(OPTION_NEW_ACCOUNT)
  }, [])
 
  const handleProceed = useCallback(() => {
    if (selectedOption === OPTION_USE_EXISTING) {
      getOrderServices({
        fxbuyflowSessionId,
        isEcConversion: true,
        onComplete: onCancel
      })
    }
    else{
      onCancel()
    }
  }, [selectedOption, onCancel, getOrderServices, fxbuyflowSessionId])

  return (
    <StyledModal
      title="Existing Account Found On Current Location"
      visible={visible}
      allowClose={false}
      footer={false}
      maskClosable={false}
      width={600}
      keyboard={false}
    >
      {locationAddress && (
        <AddressRow>
          <strong>Current Address:</strong> {locationAddress}
        </AddressRow>
      )}
      <RadioGroup>
        <Radio
          id="existing-account-use-existing"
          name="existing-account"
          checked={selectedOption === OPTION_USE_EXISTING}
          onChange={handleUseExistingChange}
          ariaLabel={existingServicesWithBanText}
        >
          {existingServicesWithBanText}
        </Radio>
        <Radio
          id="existing-account-new-account"
          name="existing-account"
          checked={selectedOption === OPTION_NEW_ACCOUNT}
          onChange={handleNewAccountChange}
          ariaLabel={newServicesText}
        >
          {newServicesText}
        </Radio>
      </RadioGroup>
      <strong>One selection is required to continue.</strong>
      <Footer>
        <StyledButton
          type="primary"
          disabled={selectedOption === null}
          onClick={handleProceed}
        >
          Proceed
        </StyledButton>
      </Footer>
    </StyledModal>
  )
}

ExistingAccountModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  getOrderServices: PropTypes.func.isRequired,
  fxbuyflowSessionId: PropTypes.string,
  existingServicesWithBanText: PropTypes.string,
  newServicesText: PropTypes.string,
  locationAddress: PropTypes.string
}

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 5px 10px;
  }
  .ant-modal-header {
    text-align: center;
  }
  .ant-modal-title {
    font-size: 1.2rem;
  }
`

const AddressRow = styled.div`
  margin-bottom: 16px;
  font-size: 0.95rem;
`

const RadioGroup = styled.div`
  margin: 0 0 20px 0;
`

const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`

const StyledButton = styled(Button)`
  margin-left: 10px;
`

export default ExistingAccountModal
